import React from "react";
import styled from "styled-components";
import DashboardDateSelector from "../dashboard/DateSelector";

export default function ReportDateField({value, onChange, label = "기간", fullWidth = false}) {
  return (
    <Field $fullWidth={fullWidth}>
      <Label>{label}</Label>
      <DashboardDateSelector value={value} onChange={onChange}/>
    </Field>
  );
}

const Field = styled.div`
  min-width:0;
  ${({$fullWidth}) => $fullWidth && "grid-column:1 / -1;"}

  .react-datepicker-wrapper input {
    border:1px solid #cfd8e3 !important;
    box-shadow:0 1px 2px rgba(31,41,55,.04);
  }

  .react-datepicker-wrapper input:hover {
    border-color:var(--color-primary-focus) !important;
  }

  .react-datepicker-wrapper input:focus {
    border-color:var(--color-primary) !important;
    box-shadow:0 0 0 3px rgba(59,130,246,.1);
  }

  @media(max-width:620px) {
    grid-column:auto;
  }
`;

const Label = styled.label`
  display:block;
  margin-bottom:7px;
  color:#444;
  font-size:var(--font-size-13);
  font-weight:700;
`;
